var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcoMessage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 33.4 32.52",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;stroke:#4563ab;stroke-linecap:round;stroke-width:1.5px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Component_14_29"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_85",
    className: "cls-1",
    d: "m26.09,31.76c-.34,0-.67-.15-.9-.41l-3.8-4.35c-1.53.39-3.11.59-4.69.59-4.07.05-8.03-1.31-11.2-3.86C.22,19.74-.82,12.21,3.19,6.92c.66-.87,1.44-1.65,2.32-2.32C12.08-.54,21.32-.54,27.9,4.61c2.95,2.31,4.7,5.82,4.75,9.57-.08,4.02-2.07,7.75-5.37,10.06v6.35c0,.66-.53,1.19-1.19,1.19h0,0Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoMessage);
export default __webpack_public_path__ + "static/media/ico-message.5584445d499fa707617d97c87b06f7b1.svg";
export { ForwardRef as ReactComponent };